import styled from 'styled-components';
import { borderRadius, colorUsage, fontSize, getSpacing } from 'stylesheet';
export var YTGScoreContainer = styled.div.withConfig({
  displayName: "YTGScoreFieldstyle__YTGScoreContainer",
  componentId: "sc-17zqowm-0"
})(["margin:", " 0;"], getSpacing(4));
export var YTGScoreHeader = styled.div.withConfig({
  displayName: "YTGScoreFieldstyle__YTGScoreHeader",
  componentId: "sc-17zqowm-1"
})(["display:flex;justify-content:space-between;"]);
export var ScoreContainer = styled.div.withConfig({
  displayName: "YTGScoreFieldstyle__ScoreContainer",
  componentId: "sc-17zqowm-2"
})(["width:", ";height:", ";padding:", ";text-align:right;background-color:", ";border-radius:", ";"], getSpacing(30), getSpacing(10), getSpacing(2), function (_ref) {
  var isDanger = _ref.isDanger;
  return isDanger === true ? colorUsage.message.warning : colorUsage.message.success;
}, borderRadius.medium);
export var ScoreText = styled.div.withConfig({
  displayName: "YTGScoreFieldstyle__ScoreText",
  componentId: "sc-17zqowm-3"
})(["font-size:", ";"], fontSize.small);
export var ScoreValue = styled.div.withConfig({
  displayName: "YTGScoreFieldstyle__ScoreValue",
  componentId: "sc-17zqowm-4"
})(["font-weight:bold;font-size:", ";"], fontSize.huge);